import script from "./UserInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserInfo.vue?vue&type=script&lang=ts&setup=true"

import "./UserInfo.vue?vue&type=style&index=0&id=e6c3c2a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6c3c2a6"]])

export default __exports__